/* ============================================================================
   OSZEA Hero slideshow — autoplay + arrows + dots
   One instance per .oszea-hero-section. Degrades to a static slide when there
   is only one. Pauses on hover / focus / tab-hidden / reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  function initHero(root) {
    if (root.dataset.heroInit) return;
    root.dataset.heroInit = '1';

    var track = root.querySelector('#heroTrack, .hero-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.hero-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-dot'));
    var prevBtn = root.querySelector('.hero-arw.prev');
    var nextBtn = root.querySelector('.hero-arw.next');
    var live = root.querySelector('.hero-live');

    if (slides.length < 2) return; // nothing to rotate

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay = Math.max(2500, (parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000);
    var autoplay = root.dataset.autoplay === 'true' && !reduce;

    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('active'); }));
    var timer = null;
    var hovering = false;
    var focused = false;

    // Current slide is read from the DOM, not a cached counter, so the
    // slideshow self-heals if anything ever leaves it out of sync.
    function current() {
      var i = slides.findIndex(function (s) { return s.classList.contains('active'); });
      return i < 0 ? 0 : i;
    }

    function show(target, userAction) {
      target = ((target % slides.length) + slides.length) % slides.length;
      var cur = current();
      slides.forEach(function (s, i) {
        var on = i === target;
        s.classList.toggle('active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        var on = i === target;
        d.classList.toggle('active', on);
        d.setAttribute('aria-current', on ? 'true' : 'false');
      });
      index = target;
      if (live && target !== cur) live.textContent = 'Slide ' + (target + 1) + ' of ' + slides.length;
      if (userAction) restart();
    }

    function nextSlide() { show(current() + 1); }
    function prevSlide() { show(current() - 1); }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!autoplay || hovering || focused || document.hidden) return;
      timer = setInterval(nextSlide, delay);
    }
    function restart() { stop(); start(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { show(current() + 1, true); });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current() - 1, true); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i, true); });
    });

    root.addEventListener('mouseenter', function () { hovering = true; stop(); });
    root.addEventListener('mouseleave', function () { hovering = false; start(); });
    root.addEventListener('focusin', function () { focused = true; stop(); });
    root.addEventListener('focusout', function () { focused = false; start(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    // keyboard: left/right when a control inside the hero is focused
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current() + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current() - 1, true); }
    });

    // touch swipe
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { dx < 0 ? show(current() + 1, true) : show(current() - 1, true); }
      x0 = null;
    }, { passive: true });

    start();
  }

  function boot() {
    document.querySelectorAll('.oszea-hero-section').forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.oszea-hero-section') || (e.target.classList && e.target.classList.contains('oszea-hero-section') ? e.target : null);
    if (el) { el.removeAttribute('data-hero-init'); initHero(el); }
  });
})();
